import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionBoqItemsService } from '../services/constructionBoqItems.service';
import type { ConstructionBoqItem } from '../types/construction-boq.types';
import { toast } from 'sonner';

export function useCreateBoqItem(boqId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Partial<ConstructionBoqItem>) => 
      ConstructionBoqItemsService.createBoqItem({ ...data, boq_id: boqId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-boqs', 'items', boqId] });
      queryClient.invalidateQueries({ queryKey: ['construction-boqs', 'stats', boqId] });
      toast.success('Thêm hạng mục thành công');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi thêm hạng mục: ' + error.message);
    }
  });
}
